module.exports = __webpack_public_path__ + "img/outside_building.86f9a054.jpg";